import React from 'react';
import { useLoadScript } from '@react-google-maps/api';
import { GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_OPTIONS } from './googleMapsConfig';
import { GoogleMapsContext } from './contexts/googleMapsContext';

interface Props {
  children: React.ReactNode;
}

export const GoogleMapsProvider: React.FC<Props> = ({ children }) => {
  // Solo intentar cargar si hay una API key configurada
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey || undefined,
    libraries: GOOGLE_MAPS_LIBRARIES,
    ...GOOGLE_MAPS_OPTIONS,
    // Configuración adicional para evitar errores
    preventGoogleFontsLoading: true,
  });

  // Si hay error de carga, solo registrarlo pero dejar que la app funcione
  if (loadError) {
    console.warn('⚠️ Google Maps no disponible:', loadError.message);
    console.warn('📍 La aplicación funcionará sin autocompletado de direcciones');
  }

  // Siempre renderizar los hijos, incluso si hay error
  return (
    <GoogleMapsContext.Provider value={{ isLoaded: isLoaded && !loadError, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}; 